import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '@/lib/mixpanel';

function getUTMParams(search: string) {
  const params = new URLSearchParams(search);
  const utms: Record<string, string> = {};
  [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_content',
    'utm_term',
    'utm_id',
    'utm_source_platform',
    'utm_campaign_id',
    'utm_creative_format',
    'utm_marketing_tactic',
  ].forEach((key) => {
    const value = params.get(key);
    if (value) utms[key] = value;
  });
  return utms;
}

export function useMixpanelPageview() {
  const location = useLocation();

  useEffect(() => {
    const pageProps = {
      page: location.pathname + location.search,
      title: document.title,
      referrer: document.referrer || undefined,
      ...getUTMParams(location.search),
    };
    trackPageView(pageProps);
  }, [location]);
} 